import { InViewHookResponse } from 'react-intersection-observer';
import { ComponentType } from '@/types/cml-api';
import { INTERACTIFY_PARAM_KEY } from './constants';
import { useInteractifyParams } from './utils/use-vid-params';
import { sendCtaClickEvent } from '../analytics/datalayer/datalayer';
import { IconPlayFill } from '../icons';
import { Webengage } from '../webengage';
interface Props {
  cover: string;
  slug: string;
  componentId?: string;
  sortKey?: string;
  index: number;
  inViewRef?: InViewHookResponse['ref'];
  isSingle?: boolean;
  isPdpPage: boolean;
}
const SingleVideoItem = ({
  slug,
  componentId,
  sortKey,
  index,
  cover,
  inViewRef,
  isPdpPage
}: Props) => {
  const {
    addInteractifyParam
  } = useInteractifyParams();
  const clickVideoHandler = (videoId: string, cover: string, itemIndex: number) => {
    addInteractifyParam({
      slug: videoId,
      isPushingNewRoute: true
    });
    if ((!sortKey || !componentId) && !isPdpPage) return;
    const elementIndex = itemIndex + 1;
    const sortKeyValue = sortKey ?? null;
    const componentIdValue = componentId ?? null;
    const destinationUrl = `/videos?${INTERACTIFY_PARAM_KEY}=${videoId}`;
    sendCtaClickEvent({
      elementType: ComponentType.CarouselVideo,
      elementIndex,
      itemID: videoId,
      elementName: sortKeyValue,
      destinationUrl,
      componentId: componentIdValue,
      ImageUrl: cover
    });
    Webengage.trackCtaAction({
      banner_type: ComponentType.CarouselVideo,
      banner_name: sortKeyValue,
      banner_index: elementIndex,
      url_destination: destinationUrl,
      item_id: videoId,
      component_id: componentIdValue,
      image_url: cover
    });
  };
  return <div className='keen-slider__slide relative !h-40 !min-w-30 !max-w-30 cursor-pointer overflow-hidden rounded bg-cover bg-center shadow-[inset_0_0_0_1px_#ffffff80] lg:!h-[290px] lg:!min-w-[217px] lg:!max-w-[217px] lg:rounded-md lg:shadow-[inset_0_0_0_2px_#ffffff80]' style={{
    backgroundImage: `url(${cover})`
  }} key={slug} ref={inViewRef} onClick={() => clickVideoHandler(slug, cover, index)} data-sentry-component="SingleVideoItem" data-sentry-source-file="single-video-item.tsx">
            <IconPlayFill className='absolute right-1/2 top-1/2 z-20 box-content h-4 w-4 -translate-y-1/2 translate-x-1/2 rounded-full border border-border-gray-medium bg-black bg-opacity-20 p-2 lg:h-8 lg:w-8 lg:border-2 lg:p-4.5' data-sentry-element="IconPlayFill" data-sentry-source-file="single-video-item.tsx" />
        </div>;
};
export default SingleVideoItem;